import { useCallback, useMemo } from 'react';
import { keepPreviousData } from '@tanstack/react-query';

import { UserID } from '@playq/octopus-common';
import { UserFull } from '@playq/octopus2-auth';
import { GenericFailure } from '@playq/services-shared';

import { IUseQueryOptionsExtended, useEitherQuery } from '/api/service-hooks';
import { services2 } from '/api/services2';

export const userGetKeys: unknown[] = ['admin', 'user', 'get'];

export const useUserGet = (
  id?: UserID,
  options?: IUseQueryOptionsExtended<UserFull | undefined, GenericFailure | Error>
) => {
  const keys = useMemo(() => userGetKeys.concat(id), [id]);

  const { mutate, ...res } = useEitherQuery(
    keys,
    () => {
      if (id) {
        return services2.adminUsersService.retrieve(id);
      }
    },
    {
      placeholderData: keepPreviousData,
      ...options,
    }
  );

  const mutateDeletedUser = useCallback(
    (user: UserFull) => {
      if (res.data) {
        mutate(user);
      }
    },
    [mutate, res.data]
  );

  return {
    user: res.data,
    ...res,
    tags: keys,
    mutate,
    mutateDeletedUser,
  };
};
